import React from 'react'
import appStore from '../../assets/images/appStore.png'
import googlePlay from '../../assets/images/googlePlay.png'

export default function Footer() {
  return (
    <>
      <footer className="bg-main-light py-5">
        <div className="container">
          <h2>Get the FreshCart app</h2>
          <p>
            We will send you a link, open it on your phone to download the app
          </p>

          <div className="row">
            <div className=" col-12 col-md-9">
              <input
                className=" form-control mb-3"
                placeholder="Email..."
                type="email"
              />
            </div>
            <div className="col-12 col-md-3">
              <button className="btn bg-main text-white w-100">
                Share App Link
              </button>
            </div>
          </div>

          <div className="border-bottom border-top border-1">
            <div className="row align-items-center ">
              <div className="col-12 col-lg-6 my-4">
                <h5 className=" d-inline-block me-2">Payment Partners</h5>
                <i className="fa-brands fa-amazon-pay me-2"></i>
                <i className="fa-brands fa-cc-amex me-2"></i>
                <i className="fa-brands fa-cc-mastercard me-2"></i>
                <i className="fa-brands fa-paypal me-2"></i>
              </div>

              <div className="col-12 col-lg-6 my-4 ">
                <div className="d-flex align-items-center ms-auto">
                  <h5 className=" d-inline-block me-2">
                    Get deliveries with FreshCart
                  </h5>

                  <div className=" d-inline-block me-2">
                    <img 
                      height={40} 
                      className="w-100" 
                      src={appStore} 
                      alt="App Store Img" />
                  </div>
                  <div className=" d-inline-block me-2">
                    <img
                      height={40}
                      className="w-100"
                      src={googlePlay}
                      alt="Google Play Img"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
